export default __webpack_public_path__ + "static/media/bg-cover.13f78df6.png";